<template>
  <ObjectListTabs>
    <template slot-scope="{}">
      <b-nav-item :to="{name: 'site-about'}">About</b-nav-item>
      <b-nav-item :to="{name: 'site-tos'}">Terms of Use</b-nav-item>
      <b-nav-item :to="{name: 'site-dmca'}">Copyright</b-nav-item>
      <b-nav-item :to="{name: 'site-fees'}">Fees &amp; Payments</b-nav-item>
      <b-nav-item :to="{name: 'site-privacy'}">Privacy Policy</b-nav-item>
      <b-nav-item :to="{name: 'site-press'}">Press</b-nav-item>
    </template>
  </ObjectListTabs>
</template>

<script>
import ObjectListTabs from '@/components/widgets/ObjectListTabs'

export default {
  name: 'SiteTabs',
  components: { ObjectListTabs }
}
</script>



// WEBPACK FOOTER //
// src/components/widgets/SiteTabs.vue